import script from "./TasksTree.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksTree.vue?vue&type=script&setup=true&lang=js"

import "./TasksTree.vue?vue&type=style&index=0&id=41e4d828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e4d828"]])

export default __exports__